import { useEffect, useState } from 'react'

export const useTooltipListener = () => {
  const [openTooltip, setOpenTooltip] = useState(false)

  useEffect(() => {
    if (!openTooltip) return

    const ionContent = document.querySelector('ion-content')
    const scrollYSelector = ionContent?.shadowRoot?.querySelector('.inner-scroll.scroll-y')

    const removeTooltip = () => setOpenTooltip(false)

    scrollYSelector?.addEventListener('scroll', removeTooltip, true)

    // eslint-disable-next-line consistent-return
    return () => scrollYSelector?.removeEventListener('scroll', removeTooltip, true)
  }, [openTooltip, setOpenTooltip])

  return {
    openTooltip,
    setOpenTooltip,
  }
}
